import { Link } from 'react-router-dom'
import { PenSquare } from 'lucide-react'
import { useConversations } from '@/hooks/useConversations'
import { ConversationListItem } from '@/components/chat/ConversationListItem'
import { EmptyChatState } from '@/components/chat/EmptyChatState'

export function ChatListPage() {
  const { data: conversations, isLoading } = useConversations()

  return (
    <div className="min-h-screen">
      {/* Header */}
      <div className="sticky top-14 z-30 bg-background border-b">
        <div className="flex items-center justify-between px-4 h-12">
          <h1 className="text-lg font-semibold">Chat</h1>
          <Link
            to="/chat/new"
            className="h-9 w-9 flex items-center justify-center rounded-md hover:bg-accent"
            aria-label="New Chat"
          >
            <PenSquare className="h-5 w-5" />
          </Link>
        </div>
      </div>

      {/* Body */}
      <div className="pb-24">
        {isLoading ? (
          <div className="space-y-1">
            {Array.from({ length: 4 }).map((_, i) => (
              <div key={i} className="flex items-center gap-3 px-4 py-3">
                <div className="h-12 w-12 rounded-full bg-muted animate-pulse shrink-0" />
                <div className="flex-1 space-y-2">
                  <div className="h-4 w-32 bg-muted animate-pulse rounded" />
                  <div className="h-3 w-48 bg-muted animate-pulse rounded" />
                </div>
              </div>
            ))}
          </div>
        ) : !conversations?.length ? (
          <EmptyChatState />
        ) : (
          <div className="divide-y">
            {conversations.map((c) => (
              <ConversationListItem key={c.id} conversation={c} />
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
